import { PRODUCT_URLS } from '@podus/utils';
import { ScrollReveal } from '@podus/ui';

export default function AboutSection() {
    return (
        <section className="px-4 pt-12 pb-10 sm:px-8 sm:pt-20 sm:pb-14 lg:px-16 lg:pt-40 lg:pb-16 xl:px-20">
            <div className="mx-auto flex max-w-[1920px] flex-col gap-5 lg:flex-row lg:gap-5">
                {/* ── Left card — About ── */}
                <ScrollReveal variant="fade-right" delay={0} distance={30} className="lg:w-[60%]">
                    <div className="flex h-full flex-col justify-center rounded-[15px] bg-[#f5f5f5] p-6 sm:p-8 lg:p-17">
                        <div>
                            <h2 className="max-w-140 text-[clamp(1.8rem,4.5vw,3.2rem)] font-bold leading-[1.2] tracking-tight text-[#2D2D2D]">
                                Your Trusted Partner in Legal Intelligence
                            </h2>
                            <p className="mt-5 text-[14px] leading-[2] text-[#4E4D4D] sm:text-[15px] lg:mt-6">
                                Podus AI is an advanced legal assistant built to simplify legal processes. We provide
                                instant legal guidance, AI-powered research, smart document drafting, and access to real
                                lawyers — all in one platform. Our mission is to make justice accessible, affordable,
                                and understandable for everyone.
                            </p>
                        </div>

                        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-3 lg:mt-8">
                            <a
                                href={PRODUCT_URLS.chatpodusai}
                                className="flex items-center justify-center rounded-full bg-secondary px-8 py-3.5 text-[14px] font-bold text-white transition-transform hover:scale-[1.02] active:scale-[0.98]"
                            >
                                Get Started
                            </a>
                            <a
                                href={`${PRODUCT_URLS.podushelp}/how-it-works`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center justify-center gap-2 rounded-full border border-secondary bg-white px-6 py-3.5 text-[14px] font-bold text-secondary transition-colors hover:bg-[#f9f9f9]"
                            >
                                See How It Works
                                <span className="flex h-6 w-6 items-center justify-center rounded-full border-2 border-primary text-primary">
                                    <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M8 5v14l11-7z" />
                                    </svg>
                                </span>
                            </a>
                        </div>
                    </div>
                </ScrollReveal>

                {/* ── Right column — Single Sign In + Chart ── */}
                <div className="flex flex-col gap-5 lg:w-[40%]">
                    {/* Single Sign In card */}
                    <ScrollReveal variant="fade-left" delay={200} distance={30}>
                        <div className="relative overflow-hidden rounded-[15px] bg-[#f5f5f5]">
                            {/* Mobile layout */}
                            <div className="flex flex-col lg:hidden">
                                <div className="px-6 pt-6 pb-4">
                                    <h3 className="text-[clamp(1.6rem,6vw,2.2rem)] font-bold leading-[1.1] text-secondary">
                                        Single Sign In
                                    </h3>
                                    <p className="mt-2 text-[13px] leading-[1.5] text-[#555]">
                                        With one Podus account, you access all legal services—simple and seamless.
                                    </p>
                                </div>
                                <div className="relative max-h-48 overflow-hidden sm:max-h-56">
                                    <img
                                        src="/assets/single_login.png"
                                        alt="Single sign in"
                                        className="w-full object-cover object-top"
                                    />
                                </div>
                            </div>

                            {/* Desktop layout */}
                            <div className="hidden lg:flex lg:h-54">
                                <div className="relative shrink-0">
                                    <img
                                        src="/assets/single_login.png"
                                        alt="Single sign in"
                                        className="h-full object-cover w-[170px]"
                                    />
                                </div>
                                <div className="flex flex-col justify-center p-5 sm:p-6">
                                    <h3 className="text-xl font-extrabold leading-[1.1] text-secondary sm:text-2xl lg:text-4xl">
                                        Single
                                        <br />
                                        Sign In
                                    </h3>
                                    <p className="mt-2 leading-[1.5] text-[#5C5D5F]">
                                        With one Podus account, you access all legal services—simple and seamless.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </ScrollReveal>

                    {/* Chart card */}
                    <ScrollReveal variant="fade-up" delay={350} distance={30}>
                        <div className="overflow-hidden rounded-[15px] lg:h-55">
                            <img
                                src="/assets/single_login_chart.png"
                                alt="Analytics dashboard"
                                className="h-full w-full object-cover"
                            />
                        </div>
                    </ScrollReveal>
                </div>
            </div>
        </section>
    );
}
